import { jsxs as r, jsx as e } from "react/jsx-runtime";
import * as l from "react";
import { forwardRef as c } from "react";
import { c as n } from "./index.js-Cr0Rsuyz.mjs";
import { N as h } from "./number-indicator-z2WQOcvQ.mjs";
function d(t, a) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a
  }, t), /* @__PURE__ */ l.createElement("path", {
    fill: "currentColor",
    d: "M8 3.75a2 2 0 0 0-2 2v12.5a2 2 0 1 0 4 0V5.75a2 2 0 0 0-2-2M16 3.75a2 2 0 0 0-2 2v12.5a2 2 0 1 0 4 0V5.75a2 2 0 0 0-2-2"
  }));
}
var u = n(/* @__PURE__ */ c(d));
function v(t, a) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a
  }, t), /* @__PURE__ */ l.createElement("path", {
    fill: "currentColor",
    d: "M8.971 3.81c-1.83-1.16-4.221.156-4.221 2.323v11.732c0 2.168 2.39 3.483 4.221 2.324l9.262-5.866c1.705-1.08 1.705-3.567 0-4.647z"
  }));
}
var p = n(/* @__PURE__ */ c(v));
const w = ({
  isPlaying: t,
  currentPage: a,
  totalPages: i,
  transitionDurationMs: o = 300,
  onPlayChange: m,
  onClickAll: f
}) => {
  const s = t ? "일시정지" : "재생";
  return /* @__PURE__ */ r("div", { className: "flex h-32 w-[258px] items-center pc:h-48 pc:w-[500px]", children: [
    /* @__PURE__ */ r("div", { className: "relative flex items-center justify-center", children: [
      /* @__PURE__ */ e(
        "button",
        {
          "aria-label": s,
          className: "relative flex size-32 shrink-0 items-center justify-center pc:mr-4",
          onClick: m,
          title: s,
          type: "button",
          children: /* @__PURE__ */ e("div", { className: "size-14 pc:size-24", children: t ? /* @__PURE__ */ e(u, { className: "size-full" }) : /* @__PURE__ */ e(p, { className: "size-full" }) })
        }
      ),
      /* @__PURE__ */ e("div", { className: "absolute right-4 h-8 w-1 bg-line-neutral-weak2 pc:right-2 pc:h-16" })
    ] }),
    /* @__PURE__ */ r("div", { className: "relative ml-6 mr-10 flex grow items-center", children: [
      /* @__PURE__ */ e("div", { className: "h-1 w-full rounded-10 bg-fill-neutral-weak3 pc:h-2" }),
      /* @__PURE__ */ e(
        "div",
        {
          className: "absolute h-2 rounded-[2rem] bg-fill-neutral-main transition-transform pc:h-4",
          style: {
            width: `${1 / i * 100}%`,
            transform: `translateX(${(a - 1) * 100}%)`,
            transitionDuration: `${o}ms`
          }
        }
      )
    ] }),
    /* @__PURE__ */ e(h, { currentPage: a, onClickAll: f, totalPages: i })
  ] });
};
w.displayName = "NDS.PageIndicator";
export {
  w as P
};
